@if (ticketList){
<p-table [value]="ticketList" dataKey="ticketID" [expandedRowKeys]="expandedRows">
    <ng-template #header>
        <tr>
            <th style="width:5%"></th>
            <th style="width:5%">Type</th>
            <th style="width:10%">Cost</th>
            <th style="width:40%">Description</th>
            <th style="width:30%">Availability</th>
        </tr>
    </ng-template>
    <ng-template #body let-ticket let-expanded="expanded">
        <tr>
            <td>
                <p-button type="button" pRipple [pRowToggler]="ticket" [text]="true" severity="secondary"  [rounded]="true" ><fa-icon [icon]="['fas','chevron-down']"/></p-button>
            </td>
            <td>{{ ticket.name }}</td>
            <td>{{ ticket.cost | currency : 'GBP' }}</td>
            <td>
                <p [innerHTML]="ticket.description"></p>
                <p [innerHTML]="ticket.restrictions" class="text-xs text-lrpTicketRed"></p>
            </td>
            <td>{{ ticket.availableFrom | date:'dd-MM-yyyy'}} - {{ ticket.availableTo | date:'dd-MM-yyyy'}}</td>
        </tr>
    </ng-template>
    <ng-template #expandedrow let-ticket>
        <tr>
            <td colspan="5">
                <app-admin-ticket-edit [eventTicket]="ticket" (closeClicked)="onClose(ticket.ticketID)" />
            </td>
        </tr>
    </ng-template>
</p-table>
}